import { register } from "../../../JavaScript/Utils";

export const ShareButton = (el: HTMLElement) => {
  // Ich verstehe nicht, warum "el.querySelectorAll(".comp-share-button")" hier nicht greift
  const shareButtons = window.document.querySelectorAll(".comp-share-button");

  const copyToClipboard = (
    text: string,
    button: HTMLElement,
    labelCopied: string
  ) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        button.innerHTML = labelCopied;
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  shareButtons.forEach((button) => {
    const labelCopied = button.getAttribute("data-label-copied-link") as string;
    button.addEventListener("click", async () => {
      copyToClipboard(window.location.href, button as HTMLElement, labelCopied);
    });
  });
};

register("ShareButton", ShareButton);
